import {Component, inject, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {NgxExtendedPdfViewerModule, NgxExtendedPdfViewerService,} from "ngx-extended-pdf-viewer";
import {BicButtonComponent} from "@buildinginformationcloud/bic-ui-components";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {faArrowDownToBracket} from "@fortawesome/pro-solid-svg-icons";
import {PageHeaderComponent} from "../design/page-header/page-header.component";

@Component({
  selector: 'app-pdfviewer',
  templateUrl: './pdfviewer.component.html',
  imports: [
    NgxExtendedPdfViewerModule,
    BicButtonComponent,
    FaIconComponent,
    PageHeaderComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pdfviewer.component.scss']
})
export class PdfviewerComponent implements OnInit, OnChanges {
  private pdfViewerService = inject(NgxExtendedPdfViewerService);


  @Input()
  url: string = '';

  @Input()
  fileName: string = 'PDF Viewer';

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }
  protected readonly faArrowDownToBracket = faArrowDownToBracket;

  async downloadPdf() {
    try {
      const res = await fetch(String(this.url), {credentials: 'include'});
      if (!res.ok) {
        return;
      }

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = this.fileName ?? 'download';
      a.rel = 'noopener';
      a.click();
    } catch (error) {
      // Handle errors from fetch() or res.blob() to avoid unhandled promise rejections
      console.error('Failed to download PDF:', error);
    }
  }
}
